import * as THREE from '/assets/scripts/three.module.js';

export function calculateCleanBox(obj) {
  const targetBox = new THREE.Box3();
  let validMeshFound = false;
  obj.updateMatrixWorld(true);
  const visit=(node,isRoot=false)=>{
    if(!isRoot && node?.isComponent)return;
    if(!isRoot && node?.userData?.sffCollisionIgnore)return;
    if(node?.isMesh && node.type !== 'BoxHelper' && node.type !== 'LineSegments' && !node.isFoot){
      if(!node.geometry.boundingBox)node.geometry.computeBoundingBox();
      const currentLocalBox=node.geometry.boundingBox.clone();
      currentLocalBox.applyMatrix4(node.matrixWorld);
      if(!validMeshFound){targetBox.copy(currentLocalBox);validMeshFound=true;}
      else targetBox.union(currentLocalBox);
    }
    for(const child of node?.children||[])visit(child,false);
  };
  visit(obj,true);
  if (!validMeshFound) targetBox.setFromObject(obj);
  return targetBox;
}

export function reconcileComponentInsideCase(comp, caseObj, scene, inset = 2) {
  if (!comp?.isComponent || !caseObj?.isCase || comp.isAirCooler) return { shifted:false, reason:'skip' };
  comp.updateMatrixWorld(true);
  caseObj.updateMatrixWorld(true);
  const caseBounds = calculateCleanBox(caseObj).clone().expandByScalar(-Math.max(0, Number(inset)||0));
  const compBounds = calculateCleanBox(comp);
  const caseSize = caseBounds.getSize(new THREE.Vector3());
  const compSize = compBounds.getSize(new THREE.Vector3());
  if (compSize.x > caseSize.x + 1 || compSize.y > caseSize.y + 1 || compSize.z > caseSize.z + 1) {
    comp.runtimeContainment = { shifted:false, reason:'component_larger_than_case_axis', caseSize:caseSize.toArray(), componentSize:compSize.toArray() };
    return comp.runtimeContainment;
  }

  const delta = new THREE.Vector3();
  if (compBounds.min.x < caseBounds.min.x) delta.x += caseBounds.min.x - compBounds.min.x;
  if (compBounds.max.x > caseBounds.max.x) delta.x -= compBounds.max.x - caseBounds.max.x;
  if (compBounds.min.y < caseBounds.min.y) delta.y += caseBounds.min.y - compBounds.min.y;
  if (compBounds.max.y > caseBounds.max.y) delta.y -= compBounds.max.y - caseBounds.max.y;
  if (compBounds.min.z < caseBounds.min.z) delta.z += caseBounds.min.z - compBounds.min.z;
  if (compBounds.max.z > caseBounds.max.z) delta.z -= compBounds.max.z - caseBounds.max.z;

  if (delta.lengthSq() > 1e-6) {
    const worldPos = comp.getWorldPosition(new THREE.Vector3()).add(delta);
    if (comp.parent && comp.parent !== scene) comp.parent.worldToLocal(worldPos);
    comp.position.copy(worldPos);
    comp.updateMatrixWorld(true);
    comp.runtimeContainment = { shifted:true, delta:delta.toArray(), reason:'runtime_case_containment' };
    return comp.runtimeContainment;
  }
  comp.runtimeContainment = { shifted:false, delta:[0,0,0], reason:'inside' };
  return comp.runtimeContainment;
}

export function createHardwareBoxMesh(l, w, h, baseColorHex, _labelText, isCompFlag, typeFlag = '') {
  const isGpu = typeFlag === 'gpu';
  let realW = w, realH = h, realL = l;
  if (typeFlag === 'psu') { realW = l; realH = w; realL = h; }
  const geometry = isGpu ? new THREE.BoxGeometry(l, h, w) : new THREE.BoxGeometry(realW, realH, realL);
  const material = new THREE.MeshStandardMaterial({
    color: baseColorHex, roughness: 0.5, metalness: 0.4,
    transparent: !isCompFlag, opacity: !isCompFlag ? 0.40 : 1.0
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  mesh.uid = 'comp_' + Math.random().toString(36).substr(2, 9);
  mesh.isComponent = isCompFlag;
  mesh.isCase = !isCompFlag;
  mesh.totalModelHeight = h;
  return mesh;
}